import { z } from "zod";
import * as common from "./transcoding-profile.common";
import * as create from "./transcoding-profile.create";
const Id = z.object({ id: z.string().uuid() });
const UpdateVideoRendition = Id.and(create.CreateVideoRendition);
const UpdateAudioRendition = Id.and(create.CreateAudioRendition);
const UpdateThumbnailRendition = Id.and(create.CreateThumbnailRendition);
const UpdateVideoStream = z.object({
    type: z.literal("video"),
    gopAlignment: z.boolean(),
    renditions: z.array(Id.and(UpdateVideoRendition.or(UpdateThumbnailRendition))).max(10),
});
const UpdateAudioStream = z.object({
    type: z.literal("audio"),
    renditions: z.array(Id.and(UpdateAudioRendition)).max(10),
});
export const UpdateStream = Id.and(common.BaseStream).and(z.discriminatedUnion("type", [UpdateAudioStream, UpdateVideoStream]));
const UpdateConfig = z.object({
    streams: z.array(UpdateStream).max(5),
});
export const UpdateTranscodingProfile = z.object({
    name: z.string().min(2).max(50).optional(),
    notes: z.string().max(500).optional(),
    rawConfig: z.string().optional(),
});
//# sourceMappingURL=transcoding-profile.update.js.map